import { parseISO } from 'date-fns';
/**
 * Percent the prescribed dose differs from the standard dose: the medicine's `doseProportion` is the
 * share of the standard dose that was prescribed, so the change is `100 - doseProportion` (positive
 * when reduced, negative when increased). Null when the proportion is not set.
 */
export function getDoseChangePercent(doseProportion) {
    if (doseProportion === null || doseProportion === undefined)
        return null;
    return 100 - doseProportion;
}
export function addDaysUtc(dateMs, days) {
    const date = new Date(dateMs);
    date.setUTCDate(date.getUTCDate() + days);
    return date.getTime();
}
// A date (stored as UTC midnight) is in the past when it is before today's local midnight.
export function isInThePast(dateMs) {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return dateMs < now.getTime();
}
export function isDefined(value) {
    return value !== null && value !== undefined;
}
export function parseTimeToMinutes(time) {
    const [hours, minutes] = time.split(':').map(Number);
    return (hours ?? 0) * 60 + (minutes ?? 0);
}
export function formatMinutesToTime(totalMinutes) {
    const normalized = ((totalMinutes % 1440) + 1440) % 1440;
    const hours = Math.floor(normalized / 60);
    const minutes = normalized % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
/** Coerces a Date, epoch ms or ISO string into a valid Date, or null when empty/invalid. */
export function toDate(value) {
    if (value === null || value === undefined || value === '')
        return null;
    const date = value instanceof Date ? value : typeof value === 'number' ? new Date(value) : parseISO(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
/** Locale-aware number formatting with a fixed number of decimals; null when absent. */
export function formatNumber(value, decimals = false) {
    if (value === null || value === undefined || Number.isNaN(value))
        return null;
    return new Intl.NumberFormat(undefined, {
        minimumFractionDigits: decimals ? 2 : 0,
        maximumFractionDigits: decimals ? 2 : 0,
    }).format(value);
}
/** Joins the unique, non-empty values with the separator (default `, `); null when there are none. */
export function joinUnique(values, separator = ', ') {
    const unique = Array.from(new Set(values.filter((value) => Boolean(value))));
    return unique.length ? unique.join(separator) : null;
}
//# sourceMappingURL=functions.js.map